import { useMemo } from 'react';
import { StringUtil } from '../../../../utils';

const useNormalizeParcels = parcels =>
  useMemo(
    () =>
      parcels.map(parcel => {
        const {
          parcelCode,
          parcelNumber,
          deliveryDetails,
          product,
          service,
          invoiceDate,
          collectionDate,
          parcelStatus,
        } = parcel;

        return {
          parcelCode,
          parcelNumber,
          recipient: deliveryDetails.notificationDetails.contactName,
          postcode: deliveryDetails.address.postcode,
          description: `${StringUtil.capitalizeFirstLetters(
            service.serviceDescription
          )} - ${StringUtil.capitalizeFirstLetters(
            product.productDescription
          )}`,
          ordered: invoiceDate,
          collected: collectionDate,
          status: parcelStatus,
        };
      }),
    [parcels]
  );

export default useNormalizeParcels;
